import { createContext, useContext, useMemo } from "react";

import { getLocalStorage } from "@shared/constants";
import { useGetFeatureTogglesList } from "@payfac/services";

import type {
  FeatureToggleContextDataProps,
  FeatureToggleProviderProps,
} from "./feature-toggle.type";

export const FeatureToggleContext = createContext({} as FeatureToggleContextDataProps);

export const FeatureToggleProvider = ({ children }: FeatureToggleProviderProps) => {
  const companyId = getLocalStorage("companyId");

  const { data, isLoading } = useGetFeatureTogglesList({ companyId });

  const valueProvider = useMemo<FeatureToggleContextDataProps>(() => {
    const toggles: Record<string, boolean> = {};

    (data?.data ?? []).forEach((key) => {
      if (key) toggles[key] = true;
    });

    const isEnabled = (key: string) => toggles[key] ?? false;

    return { toggles, isLoading, isEnabled };
  }, [data, isLoading]);

  return (
    <FeatureToggleContext.Provider value={valueProvider}>
      {children}
    </FeatureToggleContext.Provider>
  );
};

export const useFeatureToggleContext = (): FeatureToggleContextDataProps => {
  return useContext(FeatureToggleContext);
};
